import { isArray } from 'lodash';
import { OlayType } from 'src/types/components/socket.type';
import { isBigInt } from './parse-bigint.helper';

export const getSupplyUnitSymbol = (unit: string) => {
  switch (unit) {
    case 'Ton':
      return 'T';
    case 'Kilogram':
      return 'KG';
    case 'Litre':
      return 'L';
    case 'Adet':
      return 'P/ST';
    default:
      return '';
  }
};

export const convertOlaylar = (response: string, errors: string[]) => {
  const olaylar: OlayType[] = [];

  const olaylarSplit = response.split('|');
  if (olaylarSplit && isArray(olaylarSplit) && olaylarSplit[0] !== '' && olaylarSplit.length) {
    olaylarSplit.forEach((olay) => {
      const olaySplit = olay.split(',');
      if (olaySplit.length < 3) errors.push(`Olaylar info is invalid ${olay}`);
      olaylar.push({
        ozneId: isBigInt(olaySplit[0]) ? BigInt(olaySplit[0]) : Number(olaySplit[0]),
        tip: Number(olaySplit[1]),
        zaman: Number(olaySplit[2]),
      });
    });
  }

  return olaylar;
};
